<template>
  <div v-if="isOpen" class="fixed inset-[0rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
    <div class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg w-full max-w-lg p-6 relative dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto">
      <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-dark-text">Dodaj koszt bramek</h2>
      <button @click="closeModal" class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-dark-text dark:hover:text-dark-border-hover">
        ×
      </button>
      <form @submit.prevent="submitEdit" class="space-y-6">
        <!-- Cena bramek -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Koszt bramek (PLN):</label>
          <input
              v-model="localData.tollCost"
              type="number"
              step="0.01"
              min="0"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.tollCost }"
              @input="validateField('tollCost')"
          />
          <span v-if="localErrors.tollCost" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.tollCost }}</span>
        </div>

        <!-- Submit -->
        <div class="flex justify-end">
          <button 
              type="submit"
              class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
          >
            Zapisz zmiany
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    editingData: Object,
    currentOrder: Object
  },
  data() {
    return {
      localData: {
        tollCost: this.editingData?.tollCost || this.currentOrder?.driverGates || '',
        orderId: this.editingData?.orderId || this.currentOrder?.id || null
      },
      localErrors: {
        tollCost: ''
      },
      isSubmitting: false // Flaga zapobiegająca wielokrotnemu kliknięciu
    };
  },
  computed: {
    isFormValid() {
      const noErrors = Object.values(this.localErrors).every(error => error === '');
      const fieldFilled = this.localData.tollCost !== '';
      return noErrors && fieldFilled;
    }
  },
  watch: {
    // Usunięto watchery, ponieważ dane są inicjowane w data
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    validateField(field) {
      if (field === 'tollCost') {
        const value = this.localData.tollCost;
        if (value === '' || value === null) {
          this.localErrors.tollCost = 'Koszt bramek jest wymagany';
        } else if (isNaN(value) || Number(value) < 0) {
          this.localErrors.tollCost = 'Koszt bramek musi być dodatnią liczbą';
        } else {
          this.localErrors.tollCost = '';
        }
      }
    },
    submitEdit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.validateField('tollCost');

      if (this.isFormValid) {
        this.$emit('submit', { orderId: this.localData.orderId, price: Number(this.localData.tollCost) });
      }
      this.isSubmitting = false;
    }
  }
};
</script>